import { GetTemplateCategoryV2, GetTemplateCategoryV2Variables } from './__generated__/GetTemplateCategoryV2'

import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

const QUERY = gql`
  query GetTemplateCategoryV2($id: String!) {
    colorTemplate: templateCategoryV2(id: $id) {
      __typename
      ... on TemplateCategoryV2 {
        id
        title
      }
      ... on TemplateCategoryErrorV2 {
        type
        error
      }
    }
    templateMessages: listTemplateMessagesV2(input: { categoryId: $id }) {
      templateMessages {
        id
        message {
          id
          text
          characters
        }
      }
    }
  }
`

export const useGetColorTemplate = (id: string) => {
  return useQuery<GetTemplateCategoryV2, GetTemplateCategoryV2Variables>(QUERY, {
    fetchPolicy: 'cache-and-network',
    variables: {
      id
    }
  })
}
